module.exports = __webpack_public_path__ + "200395867a006c93ab3f4d8f9b857b0c.svg";